import moment from "moment";
export function formatNumberInWords(value) {
    if (value >= 1000000000) {
        var crore = value / 1000000000;
        return "".concat(crore, " Cr");
    }
    else if (value >= 10000000) {
        var lakh = value / 10000000;
        return "".concat(lakh, " L");
    }
    else if (value >= 100000) {
        var formatted = value.toLocaleString("en-IN");
        return "".concat(formatted);
    }
    else if (value >= 1000) {
        var formatted = value.toLocaleString("en-IN");
        return "".concat(formatted);
    }
    else {
        return value.toString();
    }
}
export var removeEmptyObjects = function (obj) {
    if (Array.isArray(obj)) {
        // If it's an array, recursively clean its elements.
        return obj.length === 0
            ? undefined
            : obj
                .map(removeEmptyObjects)
                .filter(function (item) { return item !== undefined && item !== null; });
    }
    if (obj && typeof obj === "object") {
        var cleanedObj = {};
        // Iterate over object keys
        for (var key in obj) {
            var cleanedValue = removeEmptyObjects(obj[key]);
            // Only add the key if the value is not empty
            if (cleanedValue !== undefined &&
                cleanedValue !== null &&
                cleanedValue !== "") {
                cleanedObj[key] = cleanedValue;
            }
        }
        // If the object is empty, return undefined to remove it.
        return Object.keys(cleanedObj).length === 0 ? undefined : cleanedObj;
    }
    // For primitive values, just return the value
    return obj;
};
export var categoryWiseData = function (categoryId) {
    switch (categoryId) {
        case 268:
            return {
                name: "PMS",
                minAmount: 5000000,
                minAmountWord: "50 Lakhs",
            };
        case 293:
            return {
                name: "AIF",
                minAmount: 10000000,
                minAmountWord: "1 Crore",
            };
        default:
            return {
                name: "",
                minAmount: 0,
                minAmountWord: "50 Lakhs",
            };
    }
};
export var formatIndiaNumber = function (value) {
    var formattedValue = value.replace(/,/g, "");
    var number = Number(formattedValue);
    if (isNaN(number) || number === 0)
        return "";
    var numStr = number.toString();
    var lastThree = numStr.slice(-3);
    var otherNumbers = numStr.slice(0, -3);
    if (otherNumbers !== "") {
        lastThree = "," + lastThree;
    }
    return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
};
export var changeInRupeeFormat = function (value) {
    var formatter = new Intl.NumberFormat("en-IN", {});
    var val = value.replace(/,/g, "");
    val = Number(val);
    var newVal = formatter.format(val);
    return newVal;
};
export function convertToJSDate(dateString) {
    var date = moment(dateString, "DD/MM/YYYY", true);
    if (date.isValid()) {
        return new Date(date.toDate());
    }
    return new Date();
}
export function capitalizeWords(str) {
    return str.toLowerCase().replace(/\b\w/g, function (char) { return char.toUpperCase(); });
}
